<template>
    <div>
        <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15 width-50per"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
				placeholder="--"
                :col="1">
            </compFormQuery>

            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15 width-50per"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
                :col="1">
            </compFormEdit>
            <template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: "保存" })}}</vButton>
				<vButton class="margin-right-20" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: "取消" })}}</vButton>
			</template>
        </compWrapper>
        <compWrapper :title="$t('global.common.operate_history', { defaultValue: '操作历史' })" theme="gray" v-if="type==='query'">
			<compLog class="margin-layout" :data="logList" :columns="morelogcolumn"></compLog>
		</compWrapper>

        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpGetRemozeZipCodeOne, HttpSaveRemozeZipCodeOne } from '@/service/account';
import { mapGetters } from 'vuex';
import mixin from "../mixin"
export default {
    mixins: [mixin],
    props:['activeid','querytype'],
    data(){
        return {
            type: this.$route.params.type || this.querytype,
			id: this.$route.query.id || this.activeid,
            logList:[],
            formData:{},
            loading:false,
        }
    },
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
	},
    created(){
        this.getDetail()
    },
    computed:{
        ...mapGetters('dictionary', ['getCountryList','getCarrierAllList', 'getServiceAllList']),
        getBase(){
            return [
                {
                    // label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    label: "承运商",
                    key: "carrierCode",
                    tag:'Select',
                    // options:this.getCarrierAllList,
                    options:this.getServiceAllList.map(item=>{
                        return {value: item.attach.carrierGroupCode, label: item.label}
                    }),
                    query:true,
                    show: this.type == 'add',
                },
                {
                    label: "承运商",
                    key: "carrierCode",
                    show: this.type !== 'add',
                    query: true,
                },
                {
                    label: this.$tc('global.common.country',1,{defaultValue:'国家'}),
                    key: "regionId",
                    tag:'Select',
                    options:this.getCountryList.map(item=>{
                        return {
                            value:item.attach.id,
                            label:item.label
                        }
                    }),
                    query:true
                },
                {
                    label: this.$t('fbb.settlement.regionType',{defaultValue:'偏远类型'}),
                    key: "type",
                    tag:'Select',
                    options:this.getRemotezipType,
                },
                {
                    label: this.$t('erp.b2c.zip_code', { defaultValue: '邮编' }),
                    key: "zipCode",
                },
            ]
        },
    },
    methods:{
        getDetail(){
            this.loading = true;
            HttpGetRemozeZipCodeOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data;
                this.logList = res.data.logs;
                this.loading = false;
            },err=>{
                this.$VMessage.error(err.message);
                this.loading = false;
            })
        },
        async submit(){
            const valid = await this.$refs.editform.validate()
            if (!valid) return;
            this.loading = true;
            HttpSaveRemozeZipCodeOne({
                id:this.id,
                type:this.formData.type,
                regionId:this.formData.regionId,
                zipCode:this.formData.zipCode,
                carrierCode:this.formData.carrierCode,
            }).then(res=>{
                this.loading = false;
                this.$VMessage.success(res.message);
                this.cancel()
            },err=>{
                this.loading = false;
                this.$VMessage.error(err.message);
            })
        },
        cancel(){
            this.$router.push({ name: 'remotezipcodeList' });
        }
    }
}
</script>
